
export class Supplier {
    id: string;
    name: string;
    email: string;
    phone: string;
    contactPerson: string;
    description: string;
}
